import React from "react";
import ReactDOM from "react-dom";
import "./styles/bootstrap-layer.css";
import "./index.css";
import { OrderDetailsProvider } from "./services/component/orderDetailsService";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <OrderDetailsProvider>
      <App />
    </OrderDetailsProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
